import http from 'hub-http/clients/apiClient';
import { stringify } from 'hub-http/helpers/params';
import { buildUrl } from 'hub-http/helpers/url';
import PortalIdParser from 'PortalIdParser';
import { getApiHostForEnvironment } from '../internal/utils';
import { splitNameAndExtension } from '../utils/file';
import { MimeTypes } from '../constants/internal/MimeTypes';
const BASE_V2_URI = 'filemanager/api/v2/files';
const OCTET_STREAM_EXTENSIONS = new Set(['tgz', 'gz', 'bz2', 'xz', 'zst', 'har']);
const EXTENSIONS_TO_INCLUDE_FILENAME = new Set(['html', ...OCTET_STREAM_EXTENSIONS]);
// Temporary solution to handle non-ASCII characters in file names
const normalizeToAscii = ({
  name,
  extension
}) => {
  const normalized = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\x20-\x7E]/g, '').replace(/["\\]/g, '').trim();
  if (!normalized.trim()) {
    return extension ? `download.${extension}` : 'download';
  }
  return extension ? `${normalized}.${extension}` : normalized;
};
const getResponseContentDispositionValue = fileMeta => {
  const parts = ['attachment'];
  if (fileMeta !== null && fileMeta !== void 0 && fileMeta.extension && EXTENSIONS_TO_INCLUDE_FILENAME.has(fileMeta.extension)) {
    parts.push(`filename="${normalizeToAscii(fileMeta)}"`);
  }
  return parts.join('; ');
};
const getAttachmentParams = options => {
  const fileMeta = options.fileName ? Object.assign({}, splitNameAndExtension(options.fileName), options.extension && {
    extension: options.extension
  }) : undefined;

  // Force octet-stream for extensions that browsers misidentify:
  // - .tgz/.gz etc: Firefox truncates extensions without an explicit encoding
  // - .har: served as application/json, so browsers save with a .json extension
  const contentType = fileMeta && OCTET_STREAM_EXTENSIONS.has(fileMeta.extension) ? MimeTypes.APPLICATION_OCTET_STREAM : undefined;
  return Object.assign({}, contentType && {
    'response-content-type': contentType
  }, {
    'response-content-disposition': getResponseContentDispositionValue(fileMeta)
  });
};
const getSignedUrlParams = options => Object.assign({}, options.expirationSeconds && {
  expirationSeconds: options.expirationSeconds
}, options.isAttachment && getAttachmentParams(options));

/**
 * Makes an HTTP request to get a signed URL for the file
 */
export function fetchSignedUrl(fileId, options = {}) {
  return http.get(`${BASE_V2_URI}/${fileId}/signed-url`, {
    query: getSignedUrlParams(options)
  });
}

/**
 * Constructs a signed redirect URL for the file (does not make HTTP request)
 * @returns The constructed URL string that will redirect to the file when accessed
 */
export function getSignedRedirectUrl(fileId, options = {}) {
  return buildUrl({
    path: `${BASE_V2_URI}/${fileId}/signed-url-redirect`,
    query: stringify(Object.assign({}, getSignedUrlParams(options), {
      portalId: PortalIdParser.get()
    })),
    hostname: getApiHostForEnvironment()
  });
}